import { memo } from 'react';

import { Icon, Typography } from '@sravni/react-design-system';
import { Verification, Warning } from '@sravni/react-icons';

import styles from './styles.module.scss';

const { Text } = Typography;

type Props = {
    hasAdditionalConditions: boolean;
};

export const AdditionalService = memo(({ hasAdditionalConditions }: Props) => {
    const iconClassName = hasAdditionalConditions ? 'h-color-R100' : 'h-color-B100';
    const icon = hasAdditionalConditions ? <Warning /> : <Verification />;
    const text = hasAdditionalConditions
        ? 'При получении займа в этом МФО, внимательно изучайте условия и договор'
        : 'В МФО нет дополнительных условий и скрытых комиссий';

    return (
        <div className={styles.root}>
            <div className={styles.iconWrapper}>
                <Icon className={iconClassName} icon={icon} size={24} />
            </div>
            <Text size={14}>{text}</Text>
        </div>
    );
});
